









import hash from 'object-hash';
import { listFactory } from '@/main/pages';
import { convertToObjects } from '@/main/utils/table';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import Save from '#components/dms/button/Save.vue';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

const KEY_COLUMN_INDEX = '2';

export default listFactory(NAME, store).extend({
	components: {
		DmsEditableTable,
		'dms-save': Save,
	},
	data() {
		return {
			rowKey: KEY_COLUMN_INDEX,
		};
	},
	computed: {
		isModified(): boolean {
			return this.table.hash !== hash(this.table.rows);
		},
	},
	methods: {
		async handleSave() {
			try {
				this.startLoading();
				await apiProvider.updateList(convertToObjects(this.table));
			} finally {
				this.table.hash = hash(this.table.rows);
				this.endLoading();
			}
		},
		async loadFilter() {
			return Promise.resolve();
		},
	},
});
